<template>
<b-overlay rounded="sm" :show="loading">
  <AuthWrapper>
    <template #card>
      <div class="text-center">
        <div>
          <h2>PENT ACCESS CONTROL</h2>
        </div>

        <div>
          <p>Please sign-in to your account and start the adventure</p>
        </div>
      </div>

      <b-alert variant="danger" show>
        <div v-if="error" class="alert-body font-small-2">
          <b-card-text>
            <feather-icon icon="AlertCircleIcon" />
            <small>{{ error }}</small>
          </b-card-text>
        </div>
      </b-alert>

      <validation-observer ref="loginForm" #default="{invalid}">
        <b-form @submit.prevent="login">
          <b-form-group label="Email / Phone" label-for="login-username">
            <validation-provider #default="{ errors }" name="Email / Phone" vid="username" rules="required">
              <div class="custom-input">
                <span class="leading">
                  <RegistrationMail />
                </span>
                <input id="login-username" v-model="username" autocomplete="false" placeholder="Enter your email address or phone">
              </div>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label="Password" label-for="login-password">
            <validation-provider #default="{ errors }" name="Password" vid="password" rules="required">
              <div class="custom-input">
                <span class="leading">
                  <PasswordLock />
                </span>

                <input id="login-password" v-model="password" autocomplete="false" :type="passwordFieldType" placeholder="*****">
                <span class="trailing" @click="togglePasswordVisibility">
                  <feather-icon :icon="passwordToggleIcon" />
                </span>
              </div>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

            <div class="d-flex justify-content-end mt-1">
              <b-link :to="{ name:'auth-forgot-password' }">
                <small class="pt-2">Forgot Password?</small>
              </b-link>
            </div>
          </b-form-group>

          <div>
            <b-button class="py-1" type="submit" variant="primary" block :disabled="invalid">
              Sign in
            </b-button>
          </div>

          <!-- <b-card-text class="text-center mt-2">
            <span>New on our platform?</span>
            <b-link :to="{ name:'auth-register' }">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text>

          <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div>

          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>

            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>

            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
          </div> -->
        </b-form>
      </validation-observer>
    </template>
  </AuthWrapper>
</b-overlay>
</template>

<script>
import { get } from "lodash";
import { required } from '@validations';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import {
  BCol,
  BImg,
  BRow,
  BLink,
  BForm,
  BAlert,
  BButton,
  BOverlay,
  BCardText,
  VBTooltip,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BFormCheckbox,
  BInputGroupAppend,
} from 'bootstrap-vue'

import TurtleRentLogo from '@core/layouts/components/Logo.vue';
import AuthWrapper from "@core/components/auth-wrapper/AuthWrapper.vue";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import PasswordLock from "@/assets/svg/PasswordLock.svg";
import BottomDesign from '@/assets/svg/BottomDesign.svg';
import RegistrationMail from "@/assets/svg/RegistrationMail.svg";

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCol,
    BImg,
    BRow,
    BLink,
    BForm,
    BAlert,
    BButton,
    BOverlay,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BInputGroup,
    AuthWrapper,
    PasswordLock,
    BFormCheckbox,
    RegistrationMail,
    BInputGroupAppend,
    // BAlert,
    BottomDesign,
    TurtleRentLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      error: '',
      password: '',
      username: '',
      remember_me: '',
      passwordFieldType: "password",
      // validation rules
      required
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    }
  },
  created() {
    const { token } = this.$route.query;
    if (token) {
      this.confirmAccount(token)
    }
  },
  methods: {
    async confirmAccount(confirmAccountToken) {
      try {
        this.loading = true;
        if (confirmAccountToken) {
          await this.useJwt().mainService.auth.setAccountConfirmationToken(confirmAccountToken);

          const accountConfirmationStatus = await this.useJwt().mainService.auth.confirmAccount();
          const { activated, token } = get(accountConfirmationStatus, "data.data", {});

          if (activated) {
            this.useJwt().mainService.auth.setPasswordResetToken(token)
            this.$router.replace({
              query: {}
            });

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Your account has been activated successfully.',
              },
            })

            await this.useJwt().mainService.auth.clearAccountConfirmationToken();
            this.$router.push({
              name: "auth-reset-password"
            });
          } else {
            this.error = "Your account confirmation token has expired. Please login to get a new confirmation token.";
          }
        }
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error_message,
          },
        })
      } finally {
        this.loading = true;
      }
    },
    async login() {
      try {
        this.loading = true
        this.error = "";

        const success = await this.$refs.loginForm.validate();
        if (!success) {
          throw new Error("Please check and make sure all fields are valid");
        }

        const response = await this.useJwt()
        .mainService.auth
        .login({
          username: this.username,
          password: this.password,
        });

        const response_data = response.data.data;
        const {
          mfa_auth_required
        } = response_data;

        // check if user has mfa enabled
        if (mfa_auth_required) {
          // save access token from payload into app jwt auth service
          // retrieve saved user preferred mfa method to proceed on mfa type
          const { mfa_access_token, mfa_method } = response_data;
          this.useJwt().mainService.mfaService.setMfaToken(mfa_access_token);

          // check if mfa method is app
          // proceed to authentication app QR code screen if mfa method is app
          // proceed to verify sent mfa otp if mfa method is email/sms
          this.$router.push({
              name: "security-mfa-authentication",
              params: {
                mfa_method
              }
            })
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Successful log in',
                  icon: 'EditIcon',
                  variant: 'success',
                  text: 'Kindly enter your otp'
                },
              });
            })
            .catch(() => {});
        } else {
          const { user, settings, access_token } = response_data;

          this.useJwt().mainService.auth.setToken(access_token)

          const days_before_password_expire_reminder = this.getValueFromSource(settings, "security_settings.days_before_password_expire_reminder", 0)
          const next_route = user.days_before_password_expire <= days_before_password_expire_reminder ? "security-password-expiry" : "home"

          await this.$router.replace({
            name: next_route
          }).catch(() => {});

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Welcome ${this.getValueFromSource(user, "member_profile.first_name", "") || this.getValueFromSource(user, "member_profile.last_name", "")}`,
              icon: 'CoffeeIcon',
              variant: 'success',
              text: `You have successfully logged in as ${user.user_type}.`,
            },
          });
        }
      } catch (error) {
        console.log(error);
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.error = error_message
      } finally {
        this.loading = false;
      }
    },
    togglePasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

sup {
  font-size: 1rem;
}
</style>
